'use client'
import { FunctionComponent } from 'react'
import cn from 'classnames'

import { ButtonLink } from '@/components/ButtonLink'
import { HeaderTag } from '@/components/HeaderTag'

import moduleStyles from '@/modules/HomePage/HomePage.module.scss'
import styles from './AboutSection.module.scss'

type AboutSectionProps = {
  className?: string
}
export const AboutSection: FunctionComponent<AboutSectionProps> = ({
  className,
}) => {
  return (
    <div className={cn(className, moduleStyles.container)}>
      <HeaderTag
        icon="inspect"
        title="О нас"
        className={cn(moduleStyles.tag, styles.tag)}
      />
      <div className={moduleStyles.title}>
        Команда работает 30 лет
        <br /> Процессы настроены как часы
      </div>
      <ButtonLink
        href="/o-kompanii"
        variant="opacity"
        className={styles.moreButton}
      >
        Подробнее
      </ButtonLink>
    </div>
  )
}
